import axios from "./axios-instance"
import store from "@/store"

export default {
  sendFeedback: payload => axios(store)({
    url: "/api/feedback",
    method: "POST",
    data: payload,
  }),
}
